module.exports = __webpack_public_path__ + "img/lighthouse.2dd25bda.svg";